import { useEffect } from 'react'
import { Badge } from 'components/Badge/Badge'
import { NavBar } from 'components/NavBar/NavBar'
import { ColoredDot, Button, Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
    clearSingleResourceBooking,
    getSingleResourceBooking,
    releaseResourceBooking,
} from 'features/operations/bookingSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import { formatDateForDisplay } from 'utils/helpers'
import {
    bookingPriorities,
    bookingStatuses,
    getHolderLabel,
    getResourceLabel,
    holderTypes,
    resourceTypes,
} from '../bookingData'

export const SingleBooking = () => {
    const { id } = useParams()
    const dispatch = useDispatch<AppDispatch>()
    const { singleBooking } = useSelector((state: RootState) => state.resourceBookings)

    useEffect(() => {
        dispatch(getSingleResourceBooking(id))
        return () => {
            dispatch(clearSingleResourceBooking())
        }
    }, [id])

    const status = singleBooking?.isActive ? bookingStatuses[0] : bookingStatuses[1]

    const handleRelease = () => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(releaseResourceBooking({ id: Number(id) }))
                    dispatch(getSingleResourceBooking(id))
                },
                word: 'release this booking',
            }),
        )
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex center gap='1rem'>
                <H1WithBack title={`Booking #${id}`} arrow />
                <Badge text={status.label} green={singleBooking?.isActive} orange={!singleBooking?.isActive} />
                {singleBooking?.isActive && (
                    <Flex width='100%' justend>
                        <Button onClick={handleRelease}>Release</Button>
                    </Flex>
                )}
            </Flex>
            <Flex gap='1rem' width='100%' style={{ marginTop: '2rem' }}>
                <Container>
                    <ContainerHeader>
                        <TitleText weight='bold'>Resource</TitleText>
                    </ContainerHeader>
                    <ContainerContent>
                        <Flex width='100%'>
                            <Flex column gap='0.2rem' width='100%'>
                                <OtherText grey>TYPE</OtherText>
                                <TitleText>{resourceTypes.find((type) => type.value === singleBooking?.resourceType)?.label || 'N / A'}</TitleText>
                            </Flex>
                            <Flex column gap='0.2rem' width='100%'>
                                <OtherText grey>RESOURCE</OtherText>
                                <TitleText>{singleBooking ? getResourceLabel(singleBooking) : 'N / A'}</TitleText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>
                <Container>
                    <ContainerHeader>
                        <TitleText weight='bold'>Holder</TitleText>
                    </ContainerHeader>
                    <ContainerContent>
                        <Flex width='100%'>
                            <Flex column gap='0.2rem' width='100%'>
                                <OtherText grey>TYPE</OtherText>
                                <TitleText>{holderTypes.find((type) => type.value === singleBooking?.holderType)?.label || 'N / A'}</TitleText>
                            </Flex>
                            <Flex column gap='0.2rem' width='100%'>
                                <OtherText grey>HOLDER</OtherText>
                                <TitleText>{singleBooking ? getHolderLabel(singleBooking) : 'N / A'}</TitleText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>
            </Flex>
            <Container style={{ marginTop: '1rem' }}>
                <ContainerHeader>
                    <TitleText weight='bold'>Window</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex width='100%'>
                        <Flex column gap='0.2rem' width='100%'>
                            <OtherText grey>PRIORITY</OtherText>
                            <TitleText>{bookingPriorities.find((priority) => priority.value === singleBooking?.priority)?.label || 'N / A'}</TitleText>
                        </Flex>
                        <Flex column gap='0.2rem' width='100%'>
                            <OtherText grey>START</OtherText>
                            <TitleText>{formatDateForDisplay(singleBooking?.startAt)}</TitleText>
                        </Flex>
                        <Flex column gap='0.2rem' width='100%'>
                            <OtherText grey>END</OtherText>
                            <TitleText>{formatDateForDisplay(singleBooking?.endAt)}</TitleText>
                        </Flex>
                        <Flex column gap='0.2rem' width='100%'>
                            <OtherText grey>CREATED</OtherText>
                            <TitleText>{formatDateForDisplay(singleBooking?.createdAt)}</TitleText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
        </PageWrapper>
    </>
}
